
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 400"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h600v400H0z"}}),_c('path',{attrs:{"fill":"#002868","d":"M0 100h600v200H0z"}}),_c('circle',{attrs:{"fill":"#fff","cx":"300","cy":"200","r":"80"}})])
          )
        }
      }
    